import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgArrowUp(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M18.2929 10.2852C18.6834 10.6757 19.3166 10.6757 19.7071 10.2852C20.0976 9.89463 20.0976 9.26147 19.7071 8.87094L13.4143 2.58432C12.6332 1.80327 11.3669 1.80327 10.5858 2.58432L4.28911 8.87485C3.89858 9.26537 3.89858 9.89854 4.28911 10.2891C4.67963 10.6796 5.3128 10.6796 5.70332 10.2891L11 5L11 21C11 21.5523 11.4478 21.9961 12 21.9961C12.5523 21.9961 13 21.5523 13 21L13 5L18.2929 10.2852Z", fill: "currentColor" })));
}
export default SvgArrowUp;
